
import { defineComponent } from "vue";
import { state } from "@/state";

export default defineComponent({
  name: "Modal",
  setup() {
    return { state };
  }
});
